import { type OrderBy } from '@inpart-io/devtools-iap';

/**
 * Prefix used for pagination module keys.
 */
export const PAGINATION_PREFIX = 'PG';

/**
 * Default delay (in milliseconds) for pagination loading.
 */
export const PAGINATION_LOADING_DELAY = 600;

/**
 * Default number of rows per page for pagination.
 */
export const PAGINATION_DEFAULT_ROWS_PER_PAGE = 25;

/**
 * Default  small number of rows per page for pagination.
 */
export const PAGINATION_DEFAULT_ROWS_PER_PAGE_SM = 10;

/**
 * Specifies the direction constants for the order by (ASC or DESC).
 */
export const ORDER_BY_DIR = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

/**
 * Default sorting configuration for pagination.
 * Specifies the attribute to sort by and the direction (ASC or DESC).
 */
export const PAGINATION_DEFAULT_ORDER_BY: OrderBy = { attribute: 'name', direction: ORDER_BY_DIR.ASC };
